import { z } from "zod";
import { NodeFactSchema } from "./ideation-maps.js";
export const SubjectKnowledgeCandidateKindSchema = z.literal("fact");
export const SubjectKnowledgeCandidateStatusSchema = z.enum(["pending", "rejected", "applied"]);
export const SubjectKnowledgeCandidateProposalChannelSchema = z.enum([
    "human",
    "ask",
    "mcp_capture",
    "extract_assist",
    "attention_4e",
]);
export const SubjectKnowledgeCandidateSourceRefSchema = z.object({
    kind: z.string().min(1),
    ref: z.string().min(1),
    span: z.string().max(400).optional(),
});
export const SubjectKnowledgeCandidateProvenanceSchema = z.object({
    sourceRef: SubjectKnowledgeCandidateSourceRefSchema.nullable(),
    vaultDocumentId: z.string().uuid().nullable(),
    title: z.string().nullable(),
    excerpt: z.string().max(400).nullable(),
    excerptSha256: z
        .string()
        .regex(/^[0-9a-f]{64}$/)
        .nullable(),
    extractSha256: z
        .string()
        .regex(/^[0-9a-f]{64}$/)
        .nullable(),
    retrieval: z.enum(["retrieved", "identified", "unavailable", "manual"]).nullable(),
    extractionStatus: z.string().nullable().optional(),
    proposedAt: z.string().datetime(),
    proposedBy: z.string().min(1).max(320),
    proposalChannel: SubjectKnowledgeCandidateProposalChannelSchema,
    conversationId: z.string().uuid().optional(),
    messageId: z.string().max(80).optional(),
    rationale: z.string().max(400).nullable().optional(),
    mcpTool: z.string().max(80).optional(),
});
const candidateFactFields = NodeFactSchema.pick({
    key: true,
    value: true,
    unit: true,
    source: true,
    asOf: true,
    note: true,
});
export const SubjectKnowledgeCandidateCreateSchema = candidateFactFields.extend({
    excerpt: z.string().max(400).optional(),
});
export const SubjectKnowledgeCandidateFromEvidenceSchema = candidateFactFields.extend({
    documentId: z.string().uuid(),
    excerpt: z.string().min(24).max(400),
    span: z.string().max(400).optional(),
});
export const SubjectKnowledgeCandidateAskSchema = candidateFactFields.extend({
    rationale: z.string().max(400).optional(),
});
export const SubjectKnowledgeCandidateMcpSchema = candidateFactFields.extend({
    rationale: z.string().max(400).optional(),
});
export const SubjectKnowledgeCandidateAmendmentSchema = z.object({
    at: z.string().datetime(),
    by: z.string().min(1).max(320),
    before: candidateFactFields,
    after: candidateFactFields,
});
export const SubjectKnowledgeCandidateAcceptSchema = z.object({
    confirmCompeting: z.boolean().optional(),
    confirmHistorical: z.boolean().optional(),
});
export const SubjectKnowledgeCandidateAmendAndAcceptSchema = candidateFactFields
    .partial()
    .extend({
    confirmCompeting: z.boolean().optional(),
    confirmHistorical: z.boolean().optional(),
})
    .refine((data) => data.key !== undefined ||
    data.value !== undefined ||
    data.unit !== undefined ||
    data.source !== undefined ||
    data.asOf !== undefined ||
    data.note !== undefined, { message: "Amend at least one fact field." });
export const SubjectKnowledgeCandidateRejectSchema = z.object({
    rejectReason: z.string().max(400).optional(),
});
export const SubjectKnowledgeReviewDecisionSchema = z.enum([
    "add",
    "noop",
    "historical",
    "competing",
]);
export const SubjectKnowledgeCandidateSchema = candidateFactFields.extend({
    id: z.string().uuid(),
    subjectId: z.string().uuid(),
    kind: SubjectKnowledgeCandidateKindSchema,
    provenance: SubjectKnowledgeCandidateProvenanceSchema,
    provenanceFingerprint: z.string().regex(/^[0-9a-f]{64}$/),
    proposalChannel: SubjectKnowledgeCandidateProposalChannelSchema,
    status: SubjectKnowledgeCandidateStatusSchema,
    createdBy: z.string().min(1).max(320),
    createdAt: z.string().datetime(),
    reviewedBy: z.string().max(320).nullable(),
    reviewedAt: z.string().datetime().nullable(),
    amendments: z.array(SubjectKnowledgeCandidateAmendmentSchema),
    appliedMutationId: z.string().uuid().nullable(),
    rejectReason: z.string().nullable(),
    expectedLiveFingerprint: z
        .string()
        .regex(/^[0-9a-f]{64}$/)
        .nullable(),
    payload: z.record(z.unknown()).nullable(),
    parentCandidateId: z.string().uuid().nullable(),
    reviewDecision: SubjectKnowledgeReviewDecisionSchema.nullable().optional(),
    stale: z.boolean().optional(),
});
export const SubjectKnowledgeCandidateListSchema = z.object({
    candidates: z.array(SubjectKnowledgeCandidateSchema),
});
export const KnowledgeCandidateIdParamSchema = z.object({
    id: z.string().uuid(),
});
export const SubjectKnowledgeCandidateListQuerySchema = z.object({
    status: SubjectKnowledgeCandidateStatusSchema.default("pending"),
});
//# sourceMappingURL=subject-knowledge-candidates.js.map